<div class="map">
    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2877.9710723199873!2d4.9408184157273265!3d43.8356977486282!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12b5fb45503f8b21%3A0x5f2d4e718f4767bc!2sHeat%20Training!5e0!3m2!1sfr!2sfr!4v1616090737206!5m2!1sfr!2sfr" height="300" allowfullscreen="" loading="lazy"></iframe>
</div>
<div class="text-map flex flex-column justify-center">
    <caption class="caption-map">Trouvez notre studio de coaching</caption>
    <div>3 place des martinets<br>13 670 Saint Andiol</div>
</div>